import ReactDOM from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { APIProvider } from './api/context';
import { FPProvider } from './utils/fingerprint';
import { TiktokProvider } from './utils/tiktok';

import reportWebVitals from './reportWebVitals';
import routes from './routes';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <TiktokProvider>
    <FPProvider>
      <APIProvider>
        <RouterProvider router={createBrowserRouter(routes)} />
      </APIProvider>
    </FPProvider>
  </TiktokProvider>
);

reportWebVitals();
